import { defineStore } from "pinia";
import { API_ROOT } from "@/types/root-types";
import { EventSourcePolyfill } from "event-source-polyfill";
import { getCookieJWT, resetCookies } from "@/utilities/cookies";
import { extractSiteID, assignCallType } from "@/utilities/organize";

import { useAuth } from "./auth";
import { useRoot } from "./root";
import { useAnnArbor } from "./sites/ann-arbor";
import { useFlint } from "./sites/flint";
import { useDearborn } from "./sites/dearborn";


import {
    ServerEventResponse, 
    ServerEventState,  
    ISiteLookupTable, 
    AnnArborSiteID, 
    DearbornSiteID, 
    FlintSiteID 
} from "@/types/sse-types";

const EventSource = EventSourcePolyfill;

const authState = useAuth();
const rootState = useRoot();

const AnnArborState = useAnnArbor();
const FlintState = useFlint();
const DearbornState = useDearborn();

export const siteLookUp = {
    [AnnArborSiteID] : { 
        name: "Ann Arbor",
        emergency: AnnArborState.emergencyCalls, 
        nonEmergency: AnnArborState.nonEmergencyCalls,  
    },
    [DearbornSiteID] : { 
        name: "Dearborn",
        emergency: DearbornState.emergencyCalls,  
        nonEmergency: DearbornState.nonEmergencyCalls, 
    },
    [FlintSiteID] : { 
        name: "Flint", 
        emergency: FlintState.emergencyCalls, 
        nonEmergency: FlintState.nonEmergencyCalls,  
    }
}

export const useSSE = defineStore("sse", {
    state: (): ServerEventState => ({
        receivedEvents: [],
        receivedEventsSizeLimit: 10,
        connectionStatus: false
    }),
    actions: {
        assignCallToSite(incomingCallData: string | string[]) {
            console.log(incomingCallData)
        },
        async listen() {
            const source = new EventSource(`${API_ROOT}/dashboard`, {
                headers: {
                  'Authorization': getCookieJWT()
                }
              });

            source.addEventListener('open', () => this.connectionStatus = true);

            source.addEventListener('message', async (e) => {
                const deserializedEvent = await JSON.parse(e.data);
                rootState.playAlertBell = true;

                if (Array.isArray(deserializedEvent)) {
                    return deserializedEvent.map((call: ServerEventResponse) => {
                        const siteID = extractSiteID(call);
                        const site = siteLookUp[siteID];
                        const emergency = assignCallType(call);
                        emergency ? site.emergency.unshift(call) : site.nonEmergency.unshift(call);
                    })
                } 
                const siteID = extractSiteID(deserializedEvent);
                const site = siteLookUp[siteID];
                const emergency = assignCallType(deserializedEvent);
                return emergency ? site.emergency.unshift(deserializedEvent) : site.nonEmergency.unshift(deserializedEvent);
            })

            source.addEventListener('error', (e: any) => {
                this.connectionStatus = false;
                if (e.status == 401) {
                    authState.authenticated = false;
                    return resetCookies();
                }
                rootState.error = true;
            });

            source.addEventListener('ping', () => this.connectionStatus = true);
            source.addEventListener('disconnect', () => this.connectionStatus = false);
        }
    },
    getters: {
        getReceivedEvents: (state) => state.receivedEvents,
        getConnectionStatus: (state) => state.connectionStatus
    }
})
